import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
import { generateCustomColors } from './helpers';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '../typography/tg-label-two';
import styles from './styles';
const AMITYEKO_TO_SL_VARIANT = {
    primary: 'primary',
    secondary: 'text',
    danger: 'danger',
    ghost: 'text',
    floating: 'text',
};
/**
 * @dependency amityeko-tg-label-two
 *
 * @slot - The label of the button. If the `circle` property is `true`, this slot must be an icon
 *       (amityeko-icon expected).
 * @slot prefix - The button's icon prefix (amityeko-icon expected). It only works when `hasPrefix`
 *       is set to `true`.
 * @slot suffix - The button's icon suffix (amityeko-icon expected). It only works when `hasSuffix`
 *       is set to `true`.
 *
 * @cssproperty --amityeko-circle-button-size - Size of the button in case it is a circle button.
 */
export default class AmityekoButton extends LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'primary';
        this.disabled = false;
        this.circle = false;
        this.hasPrefix = false;
        this.hasSuffix = false;
        this.loading = false;
    }
    render() {
        const slVariant = AMITYEKO_TO_SL_VARIANT[this.variant];
        return html `
      <sl-button
        .variant=${slVariant}
        ?disabled=${this.disabled}
        ?circle=${this.circle}
        ?loading=${this.loading}
        style=${styleMap(generateCustomColors(this.variant, this.customColor))}
        class=${classMap({
            'amityeko-variant-primary': this.variant === 'primary',
            'amityeko-variant-secondary': this.variant === 'secondary',
            'amityeko-variant-ghost': this.variant === 'ghost',
            'amityeko-variant-floating': this.variant === 'floating',
            'amityeko-variant-danger': this.variant === 'danger',
            'amityeko-has-prefix': this.hasPrefix,
            'amityeko-has-suffix': this.hasSuffix,
        })}
      >
        ${this.hasPrefix ? html `<slot name="prefix" slot="prefix"></slot>` : null}
        ${this.circle
            ? html `<slot></slot>`
            : html `<amityeko-tg-label-two><slot></slot></amityeko-tg-label-two>`}
        ${this.hasSuffix ? html `<slot name="suffix" slot="suffix"></slot>` : null}
      </sl-button>
    `;
    }
}
AmityekoButton.styles = styles;
__decorate([
    property()
], AmityekoButton.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoButton.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoButton.prototype, "circle", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoButton.prototype, "hasPrefix", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoButton.prototype, "hasSuffix", void 0);
__decorate([
    property()
], AmityekoButton.prototype, "customColor", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoButton.prototype, "loading", void 0);
if (!customElements.get('amityeko-button')) {
    customElements.define('amityeko-button', AmityekoButton);
}
//# sourceMappingURL=index.js.map